import script from "./ProductEditCustomField.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductEditCustomField.vue?vue&type=script&setup=true&lang=js"

import "./ProductEditCustomField.vue?vue&type=style&index=0&id=b80e63a0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b80e63a0"]])

export default __exports__